import { render, staticRenderFns } from "./InvoiceList-CN.vue?vue&type=template&id=4baf8722&scoped=true"
import script from "./InvoiceList-CN.vue?vue&type=script&lang=js"
export * from "./InvoiceList-CN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf8722",
  null
  
)

export default component.exports